<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="isolation: isolate;"
  width="81" height="81">
  <rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none" />
  <g class="currentLayer">
    <g id="svg_1" class="">
      <g opacity="0.600006" id="svg_2">
        <path
          d="M40.598996093749975,79.8290224609375 C18.973996093749975,79.8290224609375 1.3809960937501273,62.23602246093742 1.3809960937501273,40.612022460937396 C1.3809960937501273,18.987022460937396 18.973996093749975,1.3940224609375491 40.598996093749975,1.3940224609375491 C62.223996093749975,1.3940224609375491 79.81599609375007,18.987022460937396 79.81599609375007,40.612022460937396 C79.81599609375007,62.23602246093742 62.223996093749975,79.8290224609375 40.598996093749975,79.8290224609375 z"
          fill="none" vector-effect="non-scaling-stroke" stroke-width="1.1" stroke-dasharray="0.168,0.841"
          class="backgroundColorStroke" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3" id="svg_3" />
      </g>

      <g opacity="0.600006" id="svg_4">
        <line x1="40.616943359375" y1="1.5989990234375" x2="40.616943359375" y2="0" vector-effect="non-scaling-stroke"
          stroke-width="1.1" class="backgroundColorStroke" stroke-linejoin="miter" stroke-linecap="square"
          stroke-miterlimit="3" id="svg_5" />
      </g>

      <g opacity="0.600006" id="svg_6">
        <line x1="40.568115234375" y1="81.2320556640625" x2="40.568115234375" y2="79.633056640625"
          vector-effect="non-scaling-stroke" stroke-width="1.1" class="backgroundColorStroke" stroke-linejoin="miter"
          stroke-linecap="square" stroke-miterlimit="3" id="svg_7" />
      </g>

      <g opacity="0.600006" id="svg_8">
        <line x1="1.598876953125" y1="40.56103515625" x2="0" y2="40.56103515625" vector-effect="non-scaling-stroke"
          stroke-width="1.1" class="backgroundColorStroke" stroke-linejoin="miter" stroke-linecap="square"
          stroke-miterlimit="3" id="svg_9" />
      </g>

      <g opacity="0.600006" id="svg_10">
        <line x1="81.197021484375" y1="40.594970703125" x2="79.597900390625" y2="40.594970703125"
          vector-effect="non-scaling-stroke" stroke-width="1.1" class="backgroundColorStroke" stroke-linejoin="miter"
          stroke-linecap="square" stroke-miterlimit="3" id="svg_11" />
      </g>

      <g opacity="0.199997" id="svg_12">
        <path
          d="M40.57899609374999,77.13602246093751 C20.442996093750025,77.13602246093751 4.058996093750011,60.75302246093747 4.058996093750011,40.61602246093753 C4.058996093750011,20.480022460937562 20.442996093750025,4.096022460937547 40.57899609374999,4.096022460937547 C60.715996093750164,4.096022460937547 77.09899609374997,20.480022460937562 77.09899609374997,40.61602246093753 C77.09899609374997,60.75302246093747 60.715996093750164,77.13602246093751 40.57899609374999,77.13602246093751 z"
          fill="none" vector-effect="non-scaling-stroke" stroke-width="1.1" class="primaryLighterColorStroke"
          stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3" id="svg_13" />
      </g>

      <path
        d="M7.859996093749942,40.704022460937495 C7.859996093749942,58.51102246093751 22.29599609375009,72.94702246093743 40.10199609375013,72.94702246093743 C57.90899609374992,72.94702246093743 72.34499609375007,58.51102246093751 72.34499609375007,40.704022460937495 C72.34499609375007,22.897022460937478 57.90899609374992,8.461022460937556 40.10199609375013,8.461022460937556 C22.29599609375009,8.461022460937556 7.859996093749942,22.897022460937478 7.859996093749942,40.704022460937495 z"
        fill="rgb(22,22,56)" id="svg_14" />
      <g class="wave-container">
        <path d="  M11,45 Q25,10 40,40 T70,43  " fill="none" vector-effect="non-scaling-stroke" stroke-width="3"
          class="accentColorStroke" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3" id="svg_15" />
      </g>
      <line x1="8.5" y1="45" x2="72" y2="45" class="accentColorStroke" stroke-width="2" stroke-dasharray="5,4" />

    </g>
  </g>

</svg>